import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarFloating: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-floating, floating-window" maskId="round-filled-radius-1-stroke-1.5-IconSidebarFloating"><path fillRule="evenodd" clipRule="evenodd" d="M20.25 4C21.2165 4 22 4.7835 22 5.75V18.25C22 19.2165 21.2165 20 20.25 20H3.75C2.7835 20 2 19.2165 2 18.25V5.75C2 4.7835 2.7835 4 3.75 4H20.25ZM14.5 10.5V16.5H18.5V10.5H14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarFloating;
